import React from "react";
import VeltCommentDialogComposerActionButton from "./VeltCommentDialogComposerActionButton/VeltCommentDialogComposerActionButton";
import VeltCommentDialogComposerAssignUser from "./VeltCommentDialogComposerAssignUser/VeltCommentDialogComposerAssignUser";
import VeltCommentDialogComposerFiles from "./VeltCommentDialogComposerFiles/VeltCommentDialogComposerFiles";
import VeltCommentDialogComposerInput from "./VeltCommentDialogComposerInput/VeltCommentDialogComposerInput";
import VeltCommentDialogComposerRecordings from "./VeltCommentDialogComposerRecordings/VeltCommentDialogComposerRecordings";
;
var VeltCommentDialogComposer = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-dialog-composer-wireframe", null, children));
};
VeltCommentDialogComposer.ActionButton = VeltCommentDialogComposerActionButton;
VeltCommentDialogComposer.AssignUser = VeltCommentDialogComposerAssignUser;
VeltCommentDialogComposer.Files = VeltCommentDialogComposerFiles;
VeltCommentDialogComposer.Input = VeltCommentDialogComposerInput;
VeltCommentDialogComposer.Recordings = VeltCommentDialogComposerRecordings;
export default VeltCommentDialogComposer;
